module.exports = __webpack_public_path__ + "static/media/feelingProud2.4cc31533.svg";